export default {
  sidebar_chat: 'Chat',
  sidebar_chatlog: 'Chat Log',
  sidebar_workorder: 'Work Order'
}
